'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.toArray = function (children) {
    var ret = [];
    _react2['default'].Children.forEach(children, function (child) {
        ret.push(child);
    });
    return ret;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next-util@0.7.0@@alicd/next-util/lib/children.js
// module id = 694
// module chunks = 0